import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Buy from '../views/Buy.vue';
import Contact from '../views/Contact.vue';
import Car from '../views/Car.vue';
import Success from '../views/Success.vue';

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/buy',
    name: 'Buy',
    component: Buy
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/car',
    name: 'Car',
    component: Car
  },
  {
    path: '/success',
    name: 'Success',
    component: Success
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置（在浏览器返回时），则返回保存的位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则滚动到页面顶部
      return { top: 0 };
    }
  }
});

export default router;
